import axios from "@/axios"

const restaurantUrl = process.env.VUE_APP_KITCHENS_ENDPOINT;

export default {
    fetchAllConcepts() {
        return axios.get(`${restaurantUrl}/concepts`)
    },
    fetchAllKitchens() {
        return axios.get(`${restaurantUrl}/kitchens`)
    },
    fetchAllPlatforms() {
        return axios.get(`${restaurantUrl}/platforms`)
    },
    fetchAllCountries() {
        return axios.get(`${restaurantUrl}/countries`);
    },
    fetchAllLocations() {
        return axios.get(`${restaurantUrl}/locations?nested=false`);
    }
};
